export default __webpack_public_path__ + "static/media/stadium-bg-ar.f12aa76c.svg";